import axios, { AxiosResponse, AxiosRequestConfig } from 'axios';
import { UserRegisterModel } from '@/models/authentication/userRegisterModel';
import ApiURLs from '@/ApiURLs';
import AuthOkResult, { TokenOpts } from '@/models/authentication/authResultModel';
import RegisterSupplementModel from '@/models/authentication/registerSupplement';

class AuthService {
  login(user: any): Promise<AxiosResponse<AuthOkResult>> {
    return axios.post(ApiURLs.login, user);
  }
  
  logout(): Promise<any> {
    return axios.post(ApiURLs.logout);
  }

  refreshToken(): Promise<AxiosResponse<TokenOpts>> {
    return axios.post(ApiURLs.refreshTokenUrl);
  }

  resetPassword(data: any): Promise<AxiosResponse<any>> {
    return axios.post(ApiURLs.resetPassword, data);
  }
  
  restorePassword(restoreModel: any) {
    return axios.post(ApiURLs.forgotPassword,restoreModel);
  }

  confirmEmail(data: any, params: any) {
    return axios.post(ApiURLs.confirmEmail, null, { params: params });
  }

  register(data: UserRegisterModel, params: any) {
    return axios.post(ApiURLs.register, data, { params: params });
  }

  supplementUserInfo(data: RegisterSupplementModel) {
    return axios.post(ApiURLs.supplementUserInfo, data);
  }

  getUser() {
    return axios.get(ApiURLs.getUser);
  }

  getUserInfo() {
    return axios.get(ApiURLs.getUserInfo);
  }

  getUserByUserName(data: any) {
    return axios.get(ApiURLs.getUserByUserName, { params: { userName: data }});
  }
 
  resendActivation(params: any) {
    return axios.post(ApiURLs.resendActivation, null, {
      params: params
    } as AxiosRequestConfig);
  }

  switchCurrentRole(currentRole: string, newRole: string) {
    return axios.post(ApiURLs.switchCurrentRole, null, {
      params: { currentRole, newRole }
    } as AxiosRequestConfig);
  }

  getUserProfile() {
    return axios.get(ApiURLs.getUserProfile);
  }

  updateUserInfo(data: any) {
    return axios.post(ApiURLs.updateUserInfo, data);
  }

  saveUserLocation(data: any) {
    return axios.post(ApiURLs.saveUserLocation, data);
  }

  getUserLocation() {
    return axios.get(ApiURLs.getUserLocation);
  }

  bumpUpReferrerForUser()
  {
    return axios.get(ApiURLs.bumpUpReferrerForUser);
  }

  getUserNotifications() {
    return axios.get(ApiURLs.getUserNotifications);
  }

  saveUserNotifications(data: { pushNotifications: any }) {
    let pushNotifications = data.pushNotifications;
  
    return axios.post(ApiURLs.saveUserNotifications, null, {
      params: { pushNotifications }
    });
  }

  updateUserNotifications(data: { pushNotifications: any }) {
    let pushNotifications = data.pushNotifications;

    return axios.put(ApiURLs.updateUserNotifications, null, {
      params: { pushNotifications }
    });
  }  

  // ---------------- REMOTE VALIDATION  ----------------- //
  validateEmail(email: string) {
    let res = axios.get(ApiURLs.validateEmail,
      {
        params:
        {
          email: email
        }
      }
    );

    return(res);
  }

  validateUserName(userName: string) {
    return axios.get(ApiURLs.validateUserName,
      { params: { userName: userName }});
  }

  validateUserNameEmail(userName: string, email: string) {
    return axios.get(ApiURLs.validateUserNameEmail,
      { params: { userName: userName, email: email }});
  } 
}

export default new AuthService();